/* eslint-disable */
import {
  Form,
  Tooltip,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MenuOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.scss";
import moment from "moment";
import PDFModal from "./component/PDFModal";
import dayjs from "dayjs";
import parse from 'html-react-parser';
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [payByList, setPayByList] = useState([]);
  const [propTypeList, setPropTypeList] = useState([]);

  const [addopen, setAddOpen] = useState(false);
  const [addRecord, setAddRecord] = useState(null);
  const [form] = Form.useForm();
  const [formTenant] = Form.useForm();
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);
  
  const handleCellClick = async (record, item, flag = false) => {
    const response = await http.get(api.getIssuedCK, { params: {
      vendorPaymentId: item.vendorPaymentId,
      propId: item.propId,
      unitId: item.unitId,
    }});
    const val = response.code === '1' ? response.data : {}
    const invoiceDateTemp = dayjs(flag ? val.invoiceDate : new Date())
    setAddRecord({ 
      ...record,
      ...val,
      vendorPaymentId: item.vendorPaymentId,
      propId: item.propId,
      unitId: item.unitId,
      invoiceDate: invoiceDateTemp,
      amount: val?.amount || 0,
      serviceStartDate: val?.serviceStartDate && dayjs(val?.serviceStartDate) || null,
      serviceEndDate: val?.serviceEndDate && dayjs(val?.serviceEndDate) || null,
      invoiceTenantDate: val?.invoiceTenantDate && dayjs(val?.invoiceTenantDate) || null,
      invoiceTenant: String(val.invoiceTenant),
      foreignId: val?.foreignId || record?.vendorUtilPaymentId,
      filePaths: val?.filePaths || [],
      isEdit: flag,
      noSubmitBtn: true,
      unitIdTemp: val?.unit || '',
      usid: val?.usid
    });
    setAddOpen(true);
  };

  const initTableHead = {
    vendid: null,
    prop: null,
    addressUnits: null,
    glAcct: null,
    propType: null,
    amount: null,
    customerAccount: null,
    payBy: null,
    invoiceTenant: null,
    historyUsid: null,
    udate: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const paymentColumns = () => {
    return [0, 1, 2].map(item => ({
      title: 'issuedCheck',
      dataIndex: `issuedCheck_${item}`,
      width: 120,
      onCell: () => ({
        style: {
          padding: "8px",
        },
      }),
      render: (text, record) => {
        if (!record.groupedPayments || !Array.isArray(record.groupedPayments)) {
          return <div>-</div>;
        }
  
        const titleMatch = {
          "green": "(Cashed)",
          "#dd4b39": "(Not Cash)",
          "#f39c12": "(Voided)",
        }

        const payment = record.groupedPayments[item];
        if (!payment) return <div>-</div>;
        const textColor = payment.color || "";
        const title = titleMatch?.[textColor] || ''
  
        return (
          <div style={{ color: textColor, cursor: 'pointer' }} onClick={() =>  handleCellClick(record, payment, true)}>
            {title && <span style={{ 
              borderBottom: `1px dashed ${textColor}`,
              paddingBottom: '2px'
            }}>
              {title}
            </span> || null}
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {payment.invoiceDate
                ? moment(new Date(payment.invoiceDate)).format("MM/DD/YYYY")
                : "-"}
            </span>
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {payment.amount
                ? new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                  }).format(parseFloat(payment.amount))
                : "-"}
            </span>
          </div>
        );
      },
    }))
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Vendor',
      dataIndex: "name",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      width:160,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center",}}>
          <span>{text}</span>
          <Tooltip title={parse(record?.preCalPre || '')}>
            <MenuOutlined
              style={{ marginLeft: 8, cursor: "pointer", color: "#a94442" }}
            />
          </Tooltip>
        </div>
      ),
      onChange: e => tableFilterFn(e, 'name')
    },
    {
      title: 'Prop',
      dataIndex: "prop",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address and Units',
      dataIndex: "addressUnits",
      titleType: 'Input',
      width:180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'addressUnits')
    },
    {
      title: 'Gl-Title',
      dataIndex: "glAcct",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Prop Type',
      dataIndex: "propType",
      titleType: 'Select',
      width:80,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: propTypeList,
      onChange: e => tableFilterFn(e, 'propType', 'Select'),
    },
    {
      title: 'Pay Amount',
      dataIndex: "amount",
      titleType: 'Input',
      width:100,
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)}
          </span>
        );
      },
      onChange: e => tableFilterFn(e, 'amount'),
    },
    ...paymentColumns(),
    {
      title: 'Customer #',
      dataIndex: "customerAccount",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'customerAccount'),
    },
    {
      title: 'Pay By',
      dataIndex: "payBy",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: payByList,
      onChange: e => tableFilterFn(e, 'payBy', 'Select'),
    },
    {
      title: 'Invoice Tnt',
      dataIndex: "invoiceTenant",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
      ],
      render: (text) => {
        const invoiceTenantMatch = {
          0: "No",
          1: "Yes",
        }
        return invoiceTenantMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'invoiceTenant', 'Select'),
    },
    {
      title: 'Approval Status',
      dataIndex: "approve",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    {
      title: 'History User Id',
      dataIndex: "historyUsid",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'historyUsid'),
    },
    {
      title: 'Updated Date',
      dataIndex: "udate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY HH:mm',
      onChange: (e) => tableFilterFn(e, 'udate', 'DatePicker'),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  const PDFModalRef = useRef();

  const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.getShowApprovalOfUtil, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  //复选框
  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const getDictionaryFn = async(value) => {
    const params = {
        type:'util_payment',
        value
    }
    const response = await http.get(api.getDictionary, { params });
    switch (value) {
      case 'payBy':
        setPayByList(response)
        break;
      case 'propType':
        setPropTypeList(response)
        break;
      default:
        break;
    }
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    getDictionaryFn('payBy')
    getDictionaryFn('propType')
  }, [])

  useEffect(() => {
    if(payByList.length && propTypeList.length){
      setColumns(initColumns);
    }
  }, [payByList, propTypeList]);

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportApprovalOfUtilCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: `Util_payment`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="300px"
        tableCss="AS-tableClass"
      />

      <PDFModal ref={PDFModalRef} record={currentRecord} />

      <AddModal 
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {setAddOpen(false); getTableListFn(pagination.current, pagination.pageSize, tableHead)}}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />
    </div>
  );
});
export default MainTable;
